<ds-overview-section
  class="overview-section--policies"
  [loading]="dataLoading$ | async"
  [spinnerTextPath]="'policy.overview.spinnerText'"
  [sectionHeadingPath]="
    risks && risks.length === 1
      ? 'policy.overview.sectionHeading'
      : 'policy.overview.sectionHeadingMultiple'
  "
  data-cy="myInsuredItemsHeader"
  [newDesign]="true"
  imgSrc="/assets/images/Divider.svg"
>
  <!-- Vehicle risk card section -->
  <ds-overview-section-content>
    @if ((dataLoading$ | async) === false && (dataLoaded | async)) {
      @if (vehicleRisks.length) {
        <div
          class="risk-heading"
          dsContent
          [contentPath]="'policy.overview.riskHeading.auto'"
        ></div>
      }

      <div class="row borderless tiles policy-tiles" data-cy="policyOverviewTileContainer">
        @for (risk of vehicleRisks; track risk) {
          <div class="column pad-bottom twelve md-four">
            <ds-tile class="policy-tile" noCTAWrapper="true" tileClasses="tileClass">
              <div class="custom-tile-heading tile-heading" tile-heading>
                <div class="heading-text custom-heading-text">
                  <div class="flex items-center">
                    <span class="custom-heading-section heading-section custom-justify">{{
                      risk.description
                    }}</span>
                    <div class="custom-heading-icon">
                      <span
                        dsTabFocus
                        [ngClass]="risk.iconType || 'icon-home'"
                        role="img"
                        [attr.aria-label]="
                          (risk.vehicleTypeDisplayName || risk.policyTypeDisplayName | titleCase) +
                          ' Policy'
                        "
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              @if (risk.operator) {
                <div class="operator-info pad-left-16" tile-content>
                  <p dsContent [contentPath]="'policy.overview.listedDriver'"></p>
                  <button
                    class="info__button"
                    data-cy="infoButton"
                    triggerOn="click"
                    [heading]="toolTipContent?.header"
                    [tooltip]="toolTipContent?.toolTip"
                    [showCloseButton]="true"
                    [closeOnClickingOutside]="true"
                    [closeOnEscape]="true"
                  >
                    <i class="icon-info"></i>
                  </button>
                </div>
              }

              <div tile-cta class="tile-cta">
                <div class="flex row cta-row">
                  @if (!risk.fromSummary) {
                    <div class="column">
                      <a
                        class=""
                        dsRouterLink="/insurance-card/{{ risk.vehicleId }}"
                        (click)="sendPOIButtonAnalytics()"
                        data-cy="get-poi-button"
                        dsContent
                        [contentPath]="'policy.overview.poi'"
                      ></a>
                    </div>
                  }
                  @if (risk.operator) {
                    <div class="column">
                      <a
                        class=""
                        (click)="onGetInsuranceCardClick(risk)"
                        dsContent
                        [contentPath]="'policy.overview.poi'"
                      ></a>
                    </div>
                  }
                  @if (!risk.fromSummary && !risk.operator) {
                    <div>|</div>
                  }
                  @if (!risk.operator) {
                    @if (!!risk.fromSummary) {
                      <div class="column">
                        <a
                          class=""
                          (click)="openPolicyUnavailableModal()"
                          dsContent
                          [contentPath]="'policy.overview.policyDetails'"
                        ></a>
                      </div>
                    } @else {
                      <div class="column">
                        <a
                          class=""
                          [dsRouterLink]="[
                            '/policies',
                            risk.policyTypeName | lowercase,
                            risk.policyNumber
                          ]"
                          [queryParams]="risk.vehicleId ? { vehicleId: risk.vehicleId } : ''"
                          data-cy="policyOverviewViewDetailsButton"
                          dsContent
                          [contentPath]="'policy.overview.policyDetails'"
                        >
                        </a>
                      </div>
                    }
                  }
                </div>
              </div>
            </ds-tile>
          </div>
        }

        <!-- Add A vehicle -->
        <div class="column pad-bottom twelve md-four">
          <a data-cy="policiesOverviewAddVehiclesLink" (click)="routeToAddVehicle()">
            @if (
              (((addVehicleEnabled$ | async) && !(isPartner$ | async)) ||
                ((partnerAddVehicleEnabled$ | async) && (isPartner$ | async))) &&
              (activeAutoPolicies$ | async)?.length > 0
            ) {
              <div class="add-vehicle-card-container">
                <div class="add-vehicle-card">
                  <img
                    class="add-vehicle-img"
                    src="/assets/images/car-vector.svg"
                    alt="add vehicle image"
                  />
                  <div>
                    <span>
                      <img
                        src="/assets/images/plus.svg"
                        alt="add vehicle icon"
                        class="add-plus-icon"
                      />
                    </span>
                    @if (isPartner$ | async) {
                      <span
                        class="content"
                        dsContent
                        [contentPath]="'policy.overview.addVehicle'"
                      ></span>
                    } @else {
                      <span
                        class="content"
                        dsContent
                        [contentPath]="'policy.overview.addOrReplaceVehicle'"
                      ></span>
                    }
                  </div>
                </div>
              </div>
            }
          </a>
        </div>
      </div>
    }
  </ds-overview-section-content>

  <!-- Home risk card section -->
  <ds-overview-section-content>
    @if ((dataLoading$ | async) === false && (dataLoaded | async)) {
      @if (homeRisks.length || homesitePolicies.length) {
        <div
          class="risk-heading"
          dsContent
          [contentPath]="'policy.overview.riskHeading.home'"
        ></div>
      }

      <div class="row borderless tiles" data-cy="policyOverviewTileContainer">
        @for (risk of homeRisks; track risk) {
          <div class="column pad-bottom twelve md-four policy-tiles">
            <ds-tile class="policy-tile" noCTAWrapper="true" tileClasses="tileClass">
              <div class="custom-tile-heading tile-heading" tile-heading>
                <div class="heading-text custom-heading-text">
                  <div class="flex items-center custom-justify">
                    <span class="custom-heading-section heading-section">{{
                      risk.description
                    }}</span>
                    <div class="custom-heading-icon">
                      <span
                        dsTabFocus
                        [ngClass]="risk.iconType || 'icon-home'"
                        role="img"
                        [attr.aria-label]="
                          (risk.vehicleTypeDisplayName || risk.policyTypeDisplayName | titleCase) +
                          ' Policy'
                        "
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              <div tile-cta class="tile-cta">
                <div class="flex row cta-row">
                  @if (!risk.operator) {
                    @if (!!risk.fromSummary) {
                      <div class="column">
                        <a
                          class=""
                          (click)="openPolicyUnavailableModal()"
                          dsContent
                          [contentPath]="'policy.overview.policyDetails'"
                        ></a>
                      </div>
                    } @else {
                      @if (risk.policyTypeName !== 'Life') {
                        <div class="column">
                          <a
                            class=""
                            [dsRouterLink]="[
                              '/policies',
                              (risk.policyTypeName === 'Home' ? 'property' : risk.policyTypeName)
                                | lowercase,
                              risk.policyNumber
                            ]"
                            [queryParams]="risk.vehicleId ? { vehicleId: risk.vehicleId } : ''"
                            data-cy="policyOverviewViewDetailsButton"
                            dsContent
                            [contentPath]="'policy.overview.policyDetails'"
                          ></a>
                        </div>
                      }
                      @if (risk.policyTypeName === 'Life') {
                        <div class="column">
                          <a
                            class=""
                            [dsAnalyticsClick]="clickLifePolicyAnalytics.link"
                            [dsRouterLink]="'/policies/life/' + risk.policyNumber"
                            dsContent
                            [contentPath]="'policy.overview.policyDetails'"
                          ></a>
                        </div>
                      }
                    }
                  }
                </div>
              </div>
            </ds-tile>
          </div>
        }

        <!-- Homesite policy section, when using layer 7 -->
        @if (!userAccountExpApiEnabled) {
          @for (policy of homesitePolicies; track policy) {
            <div class="column pad-bottom twelve md-four policy-tiles">
              <ds-tile class="policy-tile" noCTAWrapper="true" tileClasses="tileClass">
                <div class="custom-tile-heading tile-heading" tile-heading>
                  <div class="heading-text custom-heading-text">
                    <div class="flex items-center custom-justify">
                      <span class="custom-heading-section heading-section">{{
                        policy.risk[0].riskDescription | prettyHomesiteRiskDescription
                      }}</span>
                      <div class="custom-heading-icon">
                        <span
                          dsTabFocus
                          class="icon-home"
                          role="img"
                          aria-label="Home Policy"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div tile-cta class="tile-cta">
                  <div class="flex row cta-row">
                    <div class="column">
                      <a
                        class=""
                        [href]="externalPropertyUrl + '&policyNumber=' + policy.policyNumber"
                        dsContent
                        [contentPath]="'policy.overview.viewDetails'"
                      ></a>
                    </div>
                  </div>
                </div>
              </ds-tile>
            </div>
          }
        }
      </div>
    }
  </ds-overview-section-content>

  <!-- Umbrella risk card section -->
  <ds-overview-section-content>
    @if ((dataLoading$ | async) === false && (dataLoaded | async)) {
      @if (umbrellaRisks.length) {
        <div
          class="risk-heading"
          dsContent
          [contentPath]="'policy.overview.riskHeading.umbrella'"
        ></div>
      }

      <div class="row borderless tiles" data-cy="policyOverviewTileContainer">
        @for (risk of umbrellaRisks; track risk) {
          <div class="column pad-bottom twelve md-four policy-tiles">
            <ds-tile class="policy-tile" noCTAWrapper="true" tileClasses="tileClass">
              <div class="custom-tile-heading tile-heading" tile-heading>
                <div class="heading-text custom-heading-text">
                  <div class="flex items-center custom-justify">
                    <span class="custom-heading-section heading-section">{{
                      risk.description
                    }}</span>
                    <div class="custom-heading-icon">
                      <span
                        dsTabFocus
                        [ngClass]="risk.iconType || 'icon-home'"
                        role="img"
                        [attr.aria-label]="
                          (risk.vehicleTypeDisplayName || risk.policyTypeDisplayName | titleCase) +
                          ' Policy'
                        "
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              <div tile-cta class="tile-cta">
                <div class="flex row cta-row">
                  @if (!risk.operator) {
                    @if (risk.policyTypeName !== 'Life') {
                      <div class="column">
                        <a
                          class=""
                          [dsRouterLink]="[
                            '/policies',
                            risk.policyTypeName | lowercase,
                            risk.policyNumber
                          ]"
                          [queryParams]="risk.vehicleId ? { vehicleId: risk.vehicleId } : ''"
                          data-cy="policyOverviewViewDetailsButton"
                          dsContent
                          [contentPath]="'policy.overview.policyDetails'"
                        ></a>
                      </div>
                    }
                    @if (risk.policyTypeName === 'Life') {
                      <div class="column">
                        <a
                          class=""
                          [dsAnalyticsClick]="clickLifePolicyAnalytics.link"
                          [dsRouterLink]="'/policies/life/' + risk.policyNumber"
                          dsContent
                          [contentPath]="'policy.overview.policyDetails'"
                        ></a>
                      </div>
                    }
                  }
                </div>
              </div>
            </ds-tile>
          </div>
        }
      </div>
    }
  </ds-overview-section-content>

  <!-- Life risk card section -->
  <ds-overview-section-content>
    @if ((dataLoading$ | async) === false && (dataLoaded | async)) {
      @if (lifeRisks.length) {
        <div
          class="risk-heading"
          dsContent
          [contentPath]="'policy.overview.riskHeading.life'"
        ></div>
      }

      <div class="row borderless tiles" data-cy="policyOverviewTileContainer">
        @for (risk of lifeRisks; track risk) {
          <div class="column pad-bottom twelve md-four policy-tiles">
            <ds-tile class="policy-tile" noCTAWrapper="true" tileClasses="tileClass">
              <div class="custom-tile-heading tile-heading" tile-heading>
                <div class="heading-text custom-heading-text">
                  <div class="flex items-center custom-justify">
                    <span class="custom-heading-section heading-section">{{
                      risk.description
                    }}</span>
                    <div class="custom-heading-icon">
                      <span
                        dsTabFocus
                        [ngClass]="risk.iconType || 'icon-home'"
                        role="img"
                        [attr.aria-label]="
                          (risk.vehicleTypeDisplayName || risk.policyTypeDisplayName | titleCase) +
                          ' Policy'
                        "
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              <div tile-cta class="tile-cta">
                <div class="flex row cta-row">
                  @if (!!risk.fromSummary) {
                    <div class="column">
                      <a
                        class=""
                        (click)="openPolicyUnavailableModal()"
                        dsContent
                        [contentPath]="'policy.overview.policyDetails'"
                      ></a>
                    </div>
                  }
                  @if (risk.policyTypeName === 'Life') {
                    <div class="column">
                      <a
                        class=""
                        [dsAnalyticsClick]="clickLifePolicyAnalytics.link"
                        [dsRouterLink]="'/policies/life/' + risk.policyNumber"
                        dsContent
                        [contentPath]="'policy.overview.policyDetails'"
                      ></a>
                    </div>
                  }
                </div>
              </div>
            </ds-tile>
          </div>
        }
      </div>
    }
  </ds-overview-section-content>

  <!-- All other risk other than auto, home, umbrella, life card section -->
  <ds-overview-section-content>
    @if ((dataLoading$ | async) === false && (dataLoaded | async)) {
      @if (allOtherRisks.length) {
        <div
          class="risk-heading"
          dsContent
          [contentPath]="'policy.overview.riskHeading.other'"
        ></div>
      }

      <div class="row borderless tiles" data-cy="policyOverviewTileContainer">
        @for (risk of allOtherRisks; track risk) {
          <div class="column pad-bottom twelve md-four policy-tiles">
            <ds-tile class="policy-tile" noCTAWrapper="true" tileClasses="tileClass">
              <div class="custom-tile-heading tile-heading" tile-heading>
                <div class="heading-text custom-heading-text">
                  <div class="flex items-center custom-justify">
                    <span class="custom-heading-section heading-section">{{
                      risk.description
                    }}</span>
                    <div class="custom-heading-icon">
                      <span
                        dsTabFocus
                        [ngClass]="risk.iconType || 'icon-home'"
                        role="img"
                        [attr.aria-label]="
                          (risk.vehicleTypeDisplayName || risk.policyTypeDisplayName | titleCase) +
                          ' Policy'
                        "
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              @if (risk.operator) {
                <div class="operator-info pad-left-16" tile-content>
                  <p dsContent [contentPath]="'policy.overview.listedDriver'"></p>
                  <button
                    class="info__button"
                    data-cy="infoButton"
                    triggerOn="click"
                    [heading]="toolTipContent?.header"
                    [tooltip]="toolTipContent?.toolTip"
                    [showCloseButton]="true"
                    [closeOnClickingOutside]="true"
                    [closeOnEscape]="true"
                  >
                    <i class="icon-info"></i>
                  </button>
                </div>
              }

              <div tile-cta class="tile-cta">
                <div class="flex row cta-row">
                  @if (
                    !risk.fromSummary &&
                    (isPartner$ | async) &&
                    risk.generalizedProductType === genericProductType.Auto
                  ) {
                    <div class="column">
                      <a
                        class=""
                        (click)="onGetInsuranceCardClick(risk)"
                        dsContent
                        [contentPath]="'policy.overview.poi'"
                      ></a>
                    </div>
                  }
                  @if (
                    !risk.fromSummary &&
                    (isPartner$ | async) === false &&
                    risk.generalizedProductType === genericProductType.Auto
                  ) {
                    <div class="column">
                      <a
                        class=""
                        dsRouterLink="/insurance-card/{{ risk.vehicleId }}"
                        (click)="sendPOIButtonAnalytics()"
                        data-cy="get-poi-button"
                        dsContent
                        [contentPath]="'policy.overview.poi'"
                      ></a>
                    </div>
                  }
                  @if (risk.operator && risk.generalizedProductType === genericProductType.Auto) {
                    <div class="column">
                      <a
                        class=""
                        (click)="onGetInsuranceCardClick(risk)"
                        dsContent
                        [contentPath]="'policy.overview.poi'"
                      ></a>
                    </div>
                  }

                  <div>|</div>

                  @if (!risk.operator) {
                    @if (!!risk.fromSummary) {
                      <div class="column">
                        <a
                          class=""
                          (click)="openPolicyUnavailableModal()"
                          dsContent
                          [contentPath]="'policy.overview.policyDetails'"
                        ></a>
                      </div>
                    } @else {
                      @if (risk.policyTypeName !== 'Life') {
                        <div class="column">
                          <a
                            class=""
                            [dsRouterLink]="[
                              '/policies',
                              (risk.policyTypeName === 'Home' ? 'property' : risk.policyTypeName)
                                | lowercase,
                              risk.policyNumber
                            ]"
                            [queryParams]="risk.vehicleId ? { vehicleId: risk.vehicleId } : ''"
                            data-cy="policyOverviewViewDetailsButton"
                            dsContent
                            [contentPath]="'policy.overview.policyDetails'"
                          >
                          </a>
                        </div>
                      }
                      @if (risk.policyTypeName === 'Life') {
                        <div class="column">
                          <a
                            class=""
                            [dsAnalyticsClick]="clickLifePolicyAnalytics.link"
                            [dsRouterLink]="'/policies/life/' + risk.policyNumber"
                            dsContent
                            [contentPath]="'policy.overview.policyDetails'"
                          ></a>
                        </div>
                      }
                    }
                  }
                </div>
              </div>
            </ds-tile>
          </div>
        }
      </div>
    }
  </ds-overview-section-content>

  <!-- This section is displayed when there are no risks -->
  <ds-overview-section-content>
    @if (
      (dataLoading$ | async) === false &&
      ((policyError | async) || risks.length === 0) &&
      homesitePolicies?.length === 0
    ) {
      <div class="row borderless tiles">
        @if (((hasSecurityQuestions | async) || forgerockEnabled) && !(isCustomer | async)) {
          <div class="column pad-bottom twelve md-four policy-tiles">
            <ds-tile class="info-tile">
              <div class="tile-heading" tile-heading>
                <div
                  dsContent
                  [contentPath]="'policy.noPoliciesToDisplay.businessUser.tileHeading'"
                ></div>
              </div>
              <div class="tile-content" tile-content>
                <div
                  dsContent
                  [contentPath]="'policy.noPoliciesToDisplay.businessUser.tileData'"
                ></div>
              </div>
              <div tile-cta class="tile-cta">
                <a dsRouterLink="/enroll/conversion" class="button">
                  <span
                    dsContent
                    [contentPath]="'policy.noPoliciesToDisplay.businessUser.ctaButtonTxt'"
                  ></span>
                </a>
              </div>
            </ds-tile>
          </div>
        }
        @if (isCustomer | async) {
          <div class="column pad-bottom twelve md-four policy-tiles">
            @if (isPartner$ | async) {
              <ds-tile class="info-tile">
                <div class="tile-heading" tile-heading>
                  <div
                    dsContent
                    [contentPath]="'policy.noPoliciesToDisplay.partners.tileHeading'"
                  ></div>
                </div>
                <div class="tile-content" tile-content>
                  <div
                    dsContent
                    [contentPath]="'policy.noPoliciesToDisplay.partners.tileData'"
                  ></div>
                </div>
                <div tile-cta class="tile-cta">
                  <a [href]="amfamDotComUrl + 'insurance'" target="_blank" class="button">
                    <span
                      dsContent
                      [contentPath]="'policy.noPoliciesToDisplay.partners.ctaButtonTxt'"
                    ></span>
                  </a>
                </div>
              </ds-tile>
            } @else {
              <ds-tile class="info-tile">
                <div class="tile-heading" tile-heading>
                  <div dsContent [contentPath]="'policy.noPoliciesToDisplay.tileHeading'"></div>
                </div>
                <div class="tile-content row" tile-content>
                  <div dsContent [contentPath]="'policy.noPoliciesToDisplay.tileData'"></div>
                </div>
              </ds-tile>
            }
          </div>
        }
      </div>
    }
  </ds-overview-section-content>
</ds-overview-section>

<ds-modal [id]="policyUnavailableModalId" [closeOthers]="true" maxWidth="300">
  <div class="policy-modal">
    <h3
      class="policy-modal__heading"
      dsContent
      [contentPath]="'policy.overview.unavailableHeading'"
    ></h3>
    <div
      class="policy-modal__content"
      dsContent
      [contentPath]="'policy.overview.unavailableContent'"
    ></div>
    <button
      ds-button
      class="policy-modal__action"
      (click)="closePolicyUnavailableModal()"
      data-cy="policyUnavailableModal"
    >
      OK
    </button>
  </div>
</ds-modal>
